"use client";

import React from "react";
import Image from "next/image";
import { PartnerProps } from "../types";

interface PartnersProps {
  partners: PartnerProps[];
  title: string;
}

const Partners: React.FC<PartnersProps> = ({ partners, title }) => {
  const getPartnerWidth = (name: string) => {
    if (name === "Roske" || name === "ALB") return "100px";
    if (name === "HCM") return "130px";
    return "160px";
  };

  const getPartnerHeight = (name: string) => {
    if (name === "HCM") return "70px";
    return "80px";
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <p className="text-omto-dark font-space-grotesk font-bold text-[21px] leading-8 mb-8 text-justify">
        {title}
      </p>

      <div className="relative overflow-hidden h-[160px]">
        <div className="absolute inset-0 flex items-center">
          <div className="partners-ticker flex items-center">
            {[...partners, ...partners, ...partners].map((partner, index) => (
              <div
                key={`${partner.name}-${Math.floor(index / partners.length)}-${index % partners.length}`}
                className="flex-shrink-0 flex items-center justify-center mx-5 group partner-item"
                style={{
                  width: getPartnerWidth(partner.name),
                  height: getPartnerHeight(partner.name),
                }}
              >
                <Image
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain partner-logo"
                  width={160}
                  height={80}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
